"use client";
import React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReCaptchaProvider } from "next-recaptcha-v3";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      })
  );
  return (
    <ReCaptchaProvider>
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools position="left" initialIsOpen={false} />
      </QueryClientProvider>
    </ReCaptchaProvider>
  );
}
